import React from "react";
import "./RodapeComponent.css";
import logo from "../../../assets/images/logo_navbar_white.png";

const RodapeComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="rodape-container">
      <div className="rodape-content">
        <div className="rodape-info">
          <h3>Atendimento</h3>
          <p>Segunda a sexta-feira: 0800 770 3004 e contatocentral@santillana.com</p>
          <p>Finais de semana: contatocentral@santillana.com</p>
          <p>
            Endereço: Rua Padre Adelino, 758 - CEP 03303-904 <br />
            Bairro Belém - São Paulo - SP
          </p>
          <p>CNPJ: 62.136.304/0001-38</p>
        </div>
        <div className="rodape-info">
          <h3>Ajuda e Suporte</h3>
          <p>
            <a className="a-link option-link clickable" href="/support">Suporte</a>
          </p>
          <p>
            <a className="a-link option-link clickable" href="/terms">Termos de uso</a>
          </p>
          <p>
            <a className="a-link option-link clickable" href="https://www.santillana.com.br/aviso-de-privacidade" target="_blank" rel="noreferrer">Política de Privacidade</a>
          </p>
        </div>
      </div>
      <div className="rodape-copyright">
        <p>
          Copyright {currentYear} © Santillana Brasil – Todos os direitos reservados.
        </p>
        <div className="rodape-logo">
          <img src={logo} alt="Santillana Logo" />
        </div>
      </div>
    </footer>
  );
};

export default RodapeComponent;